//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const AlwaysSkipDisplayIfOtherHasValueRenderingWhenHidden: FeatureFlag = {"Id":"AlwaysSkipDisplayIfOtherHasValueRenderingWhenHidden","Label":"[10.18]Always skip DisplayIfOtherHasValue rendering when hidden","Impact":"Always skip rendering DisplayIfOtherHasValue children when they are hidden. Enable 'Cache Data Table lookup results' at the same time for best performance.","Mode":0,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
